var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinkEar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 77,
    viewBox: "0 0 164 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4283 21.4298C29.0222 15.4813 36.4579 13.4889 40.8125 17.8436L59.2894 36.3204C63.644 40.675 61.6516 48.1107 55.703 49.7046L30.4632 56.4676C24.5147 58.0615 19.0714 52.6182 20.6653 46.6697L27.4283 21.4298Z",
    fill: "#FFD9EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.083 17.8437C128.437 13.489 135.873 15.4814 137.467 21.43L144.23 46.6698C145.824 52.6184 140.381 58.0617 134.432 56.4677L109.192 49.7048C103.244 48.1108 101.251 40.6751 105.606 36.3205L124.083 17.8437Z",
    fill: "#FFD9EB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkEar);
export default __webpack_public_path__ + "static/media/pink_ear.2cf28135f5dba563c608755ff58597a3.svg";
export { ForwardRef as ReactComponent };